<app-offices-table></app-offices-table>